import React from 'react';
import { WishlistButton, WishlistButtonState } from '../../WishlistButton';
import { styles } from './ProductCardHeader.css';
import { PromoTagType } from '../types';
import { ProductCardVariant } from '../ProductCard';
import BannerTag from '@jbhi-fi/lanyard-ui/components/BannerTag';
import PromoTag from '@jbhi-fi/lanyard-ui/components/PromoTag';
import { ProductCardDetails } from '../ProductCardDetails';
import { ProductDetail } from '../types';

export type ProductCardHeaderProps = {
  bannerLabel?: string;
  promoTags?: Array<PromoTagType>;
  wishlistState?: WishlistButtonState;
  shouldHideWishlist?: boolean;
  variant: ProductCardVariant;
  wishlistOnClick?: (e?: any) => void;
  shouldHideBannerTag?: boolean;
  shouldHidePromoTag?: boolean;
  details?: ProductDetail;
  productGroupId?: number;
  isProductCardDetailBadgesEnabled?: boolean;
};

export const ProductCardHeader = ({
  bannerLabel,
  promoTags,
  wishlistState,
  shouldHideWishlist,
  variant,
  wishlistOnClick,
  shouldHideBannerTag,
  shouldHidePromoTag,
  details,
  productGroupId,
  isProductCardDetailBadgesEnabled,
}: ProductCardHeaderProps) => {
  const hasWishlistButton = !!wishlistOnClick;
  const shouldDisplayWishlist = !shouldHideWishlist && !!wishlistState && hasWishlistButton;
  const shouldDisplayPromoTags = !shouldHidePromoTag && !!promoTags?.length;
  const shouldDisplayBannerTag = !shouldHideBannerTag && !!bannerLabel;
  const shouldDisplayDetailBadges = !!isProductCardDetailBadgesEnabled && !!details;
  const hasPromoBannerOrTagContent = shouldDisplayPromoTags || shouldDisplayBannerTag || shouldDisplayDetailBadges;

  const handleWishlistClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    wishlistOnClick?.(e);
  };

  return (
    <div className={styles.container({ variantType: variant, hasPromoBannerOrTagContent: hasPromoBannerOrTagContent })}>
      {hasPromoBannerOrTagContent ? (
        <div className={styles.promoTagBannerContainer}>
          {shouldDisplayBannerTag ? (
            <BannerTag testId="product-card-banner-tag" size={variant === 'small' ? 'sm' : 'lg'} label={bannerLabel} />
          ) : null}

          {shouldDisplayPromoTags
            ? promoTags.map((tag, i) => {
                return (
                  <PromoTag
                    testId={`product-card-promo-tag-${i}`}
                    size="sm"
                    key={`${tag.label}-${i}`}
                    label={tag.label}
                  />
                );
              })
            : null}

          {shouldDisplayDetailBadges ? (
            <ProductCardDetails details={details ?? null} productGroupId={productGroupId} />
          ) : null}
        </div>
      ) : null}

      {shouldDisplayWishlist ? (
        <div className={styles.wishlistButtonContainer}>
          <WishlistButton
            testId="product-card-wishlist-button"
            state={wishlistState}
            type="iconOnly"
            onClick={handleWishlistClick}
            isLoading={wishlistState === 'loading'}
            iconSize="sm"
          />
        </div>
      ) : null}
    </div>
  );
};
